/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TeacherRouteImport } from './routes/teacher'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SessionRouteImport } from './routes/session'
import { Route as ReadRouteImport } from './routes/read'
import { Route as QaPalRouteImport } from './routes/qa-pal'
import { Route as QaItemRouteImport } from './routes/qa-item'
import { Route as QaHandwritingRouteImport } from './routes/qa-handwriting'
import { Route as QaGalleryRouteImport } from './routes/qa-gallery'
import { Route as ProfilesRouteImport } from './routes/profiles'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ParentRouteImport } from './routes/parent'
import { Route as PalRouteImport } from './routes/pal'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as MascotPickRouteImport } from './routes/mascot-pick'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as JourneyRouteImport } from './routes/journey'
import { Route as DpaRouteImport } from './routes/dpa'
import { Route as DoneRouteImport } from './routes/done'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CoppaNoticeRouteImport } from './routes/coppa-notice'
import { Route as ConceptRouteImport } from './routes/concept'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlayIndexRouteImport } from './routes/play.index'
import { Route as ParentIndexRouteImport } from './routes/parent.index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding.index'
import { Route as TeacherStartRouteImport } from './routes/teacher_.start'
import { Route as PlayWhoRouteImport } from './routes/play.who'
import { Route as PlayStoryRouteImport } from './routes/play.story'
import { Route as PlaySessionRouteImport } from './routes/play.session'
import { Route as PlayRecapRouteImport } from './routes/play.recap'
import { Route as PlayReadingRouteImport } from './routes/play.reading'
import { Route as PlayMixedRouteImport } from './routes/play.mixed'
import { Route as PlayMathCoachRouteImport } from './routes/play.math-coach'
import { Route as PlayFoundationRouteImport } from './routes/play.foundation'
import { Route as PlayDayCompleteRouteImport } from './routes/play.day-complete'
import { Route as PlayCoachRouteImport } from './routes/play.coach'
import { Route as ParentTreeRouteImport } from './routes/parent.tree'
import { Route as ParentSkillRouteImport } from './routes/parent.skill'
import { Route as ParentSettingsRouteImport } from './routes/parent.settings'
import { Route as ParentPortfolioRouteImport } from './routes/parent.portfolio'
import { Route as ParentKidsRouteImport } from './routes/parent.kids'
import { Route as ParentAnalyticsRouteImport } from './routes/parent.analytics'
import { Route as OnboardingParentResultsRouteImport } from './routes/onboarding.parent-results'
import { Route as OnboardingDiagnosticRouteImport } from './routes/onboarding.diagnostic'
import { Route as JoinCodeRouteImport } from './routes/join.$code'
import { Route as ClaimCodeRouteImport } from './routes/claim.$code'
import { Route as ParentSettingsIndexRouteImport } from './routes/parent.settings.index'
import { Route as ParentSettingsSupportRouteImport } from './routes/parent.settings.support'
import { Route as ParentSettingsRoutineRouteImport } from './routes/parent.settings.routine'
import { Route as ParentSettingsPrivacyRouteImport } from './routes/parent.settings.privacy'
import { Route as ParentSettingsNotificationsRouteImport } from './routes/parent.settings.notifications'
import { Route as ParentSettingsLanguageRouteImport } from './routes/parent.settings.language'
import { Route as ParentSettingsKidsRouteImport } from './routes/parent.settings.kids'
import { Route as ParentSettingsHowItWorksRouteImport } from './routes/parent.settings.how-it-works'
import { Route as ParentSettingsEmailRouteImport } from './routes/parent.settings.email'
import { Route as ParentSettingsDifficultyRouteImport } from './routes/parent.settings.difficulty'
import { Route as ParentSettingsAccessibilityRouteImport } from './routes/parent.settings.accessibility'
import { Route as OnboardingKidPalRouteImport } from './routes/onboarding.kid.pal'
import { Route as OnboardingKidNameRouteImport } from './routes/onboarding.kid.name'
import { Route as OnboardingKidLocaleRouteImport } from './routes/onboarding.kid.locale'
import { Route as OnboardingKidHandoffRouteImport } from './routes/onboarding.kid.handoff'
import { Route as OnboardingKidAgeRouteImport } from './routes/onboarding.kid.age'
import { Route as OnboardingKidAbilitiesMathRouteImport } from './routes/onboarding.kid.abilities-math'
import { Route as OnboardingKidAbilitiesRouteImport } from './routes/onboarding.kid.abilities'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherRoute = TeacherRouteImport.update({
  id: '/teacher',
  path: '/teacher',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionRoute = SessionRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadRoute = ReadRouteImport.update({
  id: '/read',
  path: '/read',
  getParentRoute: () => rootRouteImport,
} as any)
const QaPalRoute = QaPalRouteImport.update({
  id: '/qa-pal',
  path: '/qa-pal',
  getParentRoute: () => rootRouteImport,
} as any)
const QaItemRoute = QaItemRouteImport.update({
  id: '/qa-item',
  path: '/qa-item',
  getParentRoute: () => rootRouteImport,
} as any)
const QaHandwritingRoute = QaHandwritingRouteImport.update({
  id: '/qa-handwriting',
  path: '/qa-handwriting',
  getParentRoute: () => rootRouteImport,
} as any)
const QaGalleryRoute = QaGalleryRouteImport.update({
  id: '/qa-gallery',
  path: '/qa-gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesRoute = ProfilesRouteImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentRoute = ParentRouteImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRouteImport,
} as any)
const PalRoute = PalRouteImport.update({
  id: '/pal',
  path: '/pal',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const MascotPickRoute = MascotPickRouteImport.update({
  id: '/mascot-pick',
  path: '/mascot-pick',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const JourneyRoute = JourneyRouteImport.update({
  id: '/journey',
  path: '/journey',
  getParentRoute: () => rootRouteImport,
} as any)
const DpaRoute = DpaRouteImport.update({
  id: '/dpa',
  path: '/dpa',
  getParentRoute: () => rootRouteImport,
} as any)
const DoneRoute = DoneRouteImport.update({
  id: '/done',
  path: '/done',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CoppaNoticeRoute = CoppaNoticeRouteImport.update({
  id: '/coppa-notice',
  path: '/coppa-notice',
  getParentRoute: () => rootRouteImport,
} as any)
const ConceptRoute = ConceptRouteImport.update({
  id: '/concept',
  path: '/concept',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayIndexRoute = PlayIndexRouteImport.update({
  id: '/play/',
  path: '/play/',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentIndexRoute = ParentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ParentRoute,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const TeacherStartRoute = TeacherStartRouteImport.update({
  id: '/teacher_/start',
  path: '/teacher/start',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayWhoRoute = PlayWhoRouteImport.update({
  id: '/play/who',
  path: '/play/who',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayStoryRoute = PlayStoryRouteImport.update({
  id: '/play/story',
  path: '/play/story',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaySessionRoute = PlaySessionRouteImport.update({
  id: '/play/session',
  path: '/play/session',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRecapRoute = PlayRecapRouteImport.update({
  id: '/play/recap',
  path: '/play/recap',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayReadingRoute = PlayReadingRouteImport.update({
  id: '/play/reading',
  path: '/play/reading',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayMixedRoute = PlayMixedRouteImport.update({
  id: '/play/mixed',
  path: '/play/mixed',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayMathCoachRoute = PlayMathCoachRouteImport.update({
  id: '/play/math-coach',
  path: '/play/math-coach',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayFoundationRoute = PlayFoundationRouteImport.update({
  id: '/play/foundation',
  path: '/play/foundation',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayDayCompleteRoute = PlayDayCompleteRouteImport.update({
  id: '/play/day-complete',
  path: '/play/day-complete',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayCoachRoute = PlayCoachRouteImport.update({
  id: '/play/coach',
  path: '/play/coach',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentTreeRoute = ParentTreeRouteImport.update({
  id: '/tree',
  path: '/tree',
  getParentRoute: () => ParentRoute,
} as any)
const ParentSkillRoute = ParentSkillRouteImport.update({
  id: '/skill',
  path: '/skill',
  getParentRoute: () => ParentRoute,
} as any)
const ParentSettingsRoute = ParentSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ParentRoute,
} as any)
const ParentPortfolioRoute = ParentPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => ParentRoute,
} as any)
const ParentKidsRoute = ParentKidsRouteImport.update({
  id: '/kids',
  path: '/kids',
  getParentRoute: () => ParentRoute,
} as any)
const ParentAnalyticsRoute = ParentAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => ParentRoute,
} as any)
const OnboardingParentResultsRoute = OnboardingParentResultsRouteImport.update({
  id: '/parent-results',
  path: '/parent-results',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingDiagnosticRoute = OnboardingDiagnosticRouteImport.update({
  id: '/diagnostic',
  path: '/diagnostic',
  getParentRoute: () => OnboardingRoute,
} as any)
const JoinCodeRoute = JoinCodeRouteImport.update({
  id: '/join/$code',
  path: '/join/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimCodeRoute = ClaimCodeRouteImport.update({
  id: '/claim/$code',
  path: '/claim/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentSettingsIndexRoute = ParentSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ParentSettingsRoute,
} as any)
const ParentSettingsSupportRoute = ParentSettingsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => ParentSettingsRoute,
} as any)
const ParentSettingsRoutineRoute = ParentSettingsRoutineRouteImport.update({
  id: '/routine',
  path: '/routine',
  getParentRoute: () => ParentSettingsRoute,
} as any)
const ParentSettingsPrivacyRoute = ParentSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => ParentSettingsRoute,
} as any)
const ParentSettingsNotificationsRoute =
  ParentSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ParentSettingsRoute,
  } as any)
const ParentSettingsLanguageRoute = ParentSettingsLanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => ParentSettingsRoute,
} as any)
const ParentSettingsKidsRoute = ParentSettingsKidsRouteImport.update({
  id: '/kids',
  path: '/kids',
  getParentRoute: () => ParentSettingsRoute,
} as any)
const ParentSettingsHowItWorksRoute =
  ParentSettingsHowItWorksRouteImport.update({
    id: '/how-it-works',
    path: '/how-it-works',
    getParentRoute: () => ParentSettingsRoute,
  } as any)
const ParentSettingsEmailRoute = ParentSettingsEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => ParentSettingsRoute,
} as any)
const ParentSettingsDifficultyRoute =
  ParentSettingsDifficultyRouteImport.update({
    id: '/difficulty',
    path: '/difficulty',
    getParentRoute: () => ParentSettingsRoute,
  } as any)
const ParentSettingsAccessibilityRoute =
  ParentSettingsAccessibilityRouteImport.update({
    id: '/accessibility',
    path: '/accessibility',
    getParentRoute: () => ParentSettingsRoute,
  } as any)
const OnboardingKidPalRoute = OnboardingKidPalRouteImport.update({
  id: '/kid/pal',
  path: '/kid/pal',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingKidNameRoute = OnboardingKidNameRouteImport.update({
  id: '/kid/name',
  path: '/kid/name',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingKidLocaleRoute = OnboardingKidLocaleRouteImport.update({
  id: '/kid/locale',
  path: '/kid/locale',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingKidHandoffRoute = OnboardingKidHandoffRouteImport.update({
  id: '/kid/handoff',
  path: '/kid/handoff',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingKidAgeRoute = OnboardingKidAgeRouteImport.update({
  id: '/kid/age',
  path: '/kid/age',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingKidAbilitiesMathRoute =
  OnboardingKidAbilitiesMathRouteImport.update({
    id: '/kid/abilities-math',
    path: '/kid/abilities-math',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingKidAbilitiesRoute = OnboardingKidAbilitiesRouteImport.update({
  id: '/kid/abilities',
  path: '/kid/abilities',
  getParentRoute: () => OnboardingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/concept': typeof ConceptRoute
  '/coppa-notice': typeof CoppaNoticeRoute
  '/dashboard': typeof DashboardRoute
  '/done': typeof DoneRoute
  '/dpa': typeof DpaRoute
  '/journey': typeof JourneyRoute
  '/library': typeof LibraryRoute
  '/mascot-pick': typeof MascotPickRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/pal': typeof PalRoute
  '/parent': typeof ParentRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/profiles': typeof ProfilesRoute
  '/qa-gallery': typeof QaGalleryRoute
  '/qa-handwriting': typeof QaHandwritingRoute
  '/qa-item': typeof QaItemRoute
  '/qa-pal': typeof QaPalRoute
  '/read': typeof ReadRoute
  '/session': typeof SessionRoute
  '/settings': typeof SettingsRoute
  '/teacher': typeof TeacherRoute
  '/terms': typeof TermsRoute
  '/claim/$code': typeof ClaimCodeRoute
  '/join/$code': typeof JoinCodeRoute
  '/onboarding/diagnostic': typeof OnboardingDiagnosticRoute
  '/onboarding/parent-results': typeof OnboardingParentResultsRoute
  '/parent/analytics': typeof ParentAnalyticsRoute
  '/parent/kids': typeof ParentKidsRoute
  '/parent/portfolio': typeof ParentPortfolioRoute
  '/parent/settings': typeof ParentSettingsRouteWithChildren
  '/parent/skill': typeof ParentSkillRoute
  '/parent/tree': typeof ParentTreeRoute
  '/play/coach': typeof PlayCoachRoute
  '/play/day-complete': typeof PlayDayCompleteRoute
  '/play/foundation': typeof PlayFoundationRoute
  '/play/math-coach': typeof PlayMathCoachRoute
  '/play/mixed': typeof PlayMixedRoute
  '/play/reading': typeof PlayReadingRoute
  '/play/recap': typeof PlayRecapRoute
  '/play/session': typeof PlaySessionRoute
  '/play/story': typeof PlayStoryRoute
  '/play/who': typeof PlayWhoRoute
  '/teacher/start': typeof TeacherStartRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/parent/': typeof ParentIndexRoute
  '/play/': typeof PlayIndexRoute
  '/onboarding/kid/abilities': typeof OnboardingKidAbilitiesRoute
  '/onboarding/kid/abilities-math': typeof OnboardingKidAbilitiesMathRoute
  '/onboarding/kid/age': typeof OnboardingKidAgeRoute
  '/onboarding/kid/handoff': typeof OnboardingKidHandoffRoute
  '/onboarding/kid/locale': typeof OnboardingKidLocaleRoute
  '/onboarding/kid/name': typeof OnboardingKidNameRoute
  '/onboarding/kid/pal': typeof OnboardingKidPalRoute
  '/parent/settings/accessibility': typeof ParentSettingsAccessibilityRoute
  '/parent/settings/difficulty': typeof ParentSettingsDifficultyRoute
  '/parent/settings/email': typeof ParentSettingsEmailRoute
  '/parent/settings/how-it-works': typeof ParentSettingsHowItWorksRoute
  '/parent/settings/kids': typeof ParentSettingsKidsRoute
  '/parent/settings/language': typeof ParentSettingsLanguageRoute
  '/parent/settings/notifications': typeof ParentSettingsNotificationsRoute
  '/parent/settings/privacy': typeof ParentSettingsPrivacyRoute
  '/parent/settings/routine': typeof ParentSettingsRoutineRoute
  '/parent/settings/support': typeof ParentSettingsSupportRoute
  '/parent/settings/': typeof ParentSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/concept': typeof ConceptRoute
  '/coppa-notice': typeof CoppaNoticeRoute
  '/dashboard': typeof DashboardRoute
  '/done': typeof DoneRoute
  '/dpa': typeof DpaRoute
  '/journey': typeof JourneyRoute
  '/library': typeof LibraryRoute
  '/mascot-pick': typeof MascotPickRoute
  '/pal': typeof PalRoute
  '/privacy': typeof PrivacyRoute
  '/profiles': typeof ProfilesRoute
  '/qa-gallery': typeof QaGalleryRoute
  '/qa-handwriting': typeof QaHandwritingRoute
  '/qa-item': typeof QaItemRoute
  '/qa-pal': typeof QaPalRoute
  '/read': typeof ReadRoute
  '/session': typeof SessionRoute
  '/settings': typeof SettingsRoute
  '/teacher': typeof TeacherRoute
  '/terms': typeof TermsRoute
  '/claim/$code': typeof ClaimCodeRoute
  '/join/$code': typeof JoinCodeRoute
  '/onboarding/diagnostic': typeof OnboardingDiagnosticRoute
  '/onboarding/parent-results': typeof OnboardingParentResultsRoute
  '/parent/analytics': typeof ParentAnalyticsRoute
  '/parent/kids': typeof ParentKidsRoute
  '/parent/portfolio': typeof ParentPortfolioRoute
  '/parent/skill': typeof ParentSkillRoute
  '/parent/tree': typeof ParentTreeRoute
  '/play/coach': typeof PlayCoachRoute
  '/play/day-complete': typeof PlayDayCompleteRoute
  '/play/foundation': typeof PlayFoundationRoute
  '/play/math-coach': typeof PlayMathCoachRoute
  '/play/mixed': typeof PlayMixedRoute
  '/play/reading': typeof PlayReadingRoute
  '/play/recap': typeof PlayRecapRoute
  '/play/session': typeof PlaySessionRoute
  '/play/story': typeof PlayStoryRoute
  '/play/who': typeof PlayWhoRoute
  '/teacher/start': typeof TeacherStartRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/parent': typeof ParentIndexRoute
  '/play': typeof PlayIndexRoute
  '/onboarding/kid/abilities': typeof OnboardingKidAbilitiesRoute
  '/onboarding/kid/abilities-math': typeof OnboardingKidAbilitiesMathRoute
  '/onboarding/kid/age': typeof OnboardingKidAgeRoute
  '/onboarding/kid/handoff': typeof OnboardingKidHandoffRoute
  '/onboarding/kid/locale': typeof OnboardingKidLocaleRoute
  '/onboarding/kid/name': typeof OnboardingKidNameRoute
  '/onboarding/kid/pal': typeof OnboardingKidPalRoute
  '/parent/settings/accessibility': typeof ParentSettingsAccessibilityRoute
  '/parent/settings/difficulty': typeof ParentSettingsDifficultyRoute
  '/parent/settings/email': typeof ParentSettingsEmailRoute
  '/parent/settings/how-it-works': typeof ParentSettingsHowItWorksRoute
  '/parent/settings/kids': typeof ParentSettingsKidsRoute
  '/parent/settings/language': typeof ParentSettingsLanguageRoute
  '/parent/settings/notifications': typeof ParentSettingsNotificationsRoute
  '/parent/settings/privacy': typeof ParentSettingsPrivacyRoute
  '/parent/settings/routine': typeof ParentSettingsRoutineRoute
  '/parent/settings/support': typeof ParentSettingsSupportRoute
  '/parent/settings': typeof ParentSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/concept': typeof ConceptRoute
  '/coppa-notice': typeof CoppaNoticeRoute
  '/dashboard': typeof DashboardRoute
  '/done': typeof DoneRoute
  '/dpa': typeof DpaRoute
  '/journey': typeof JourneyRoute
  '/library': typeof LibraryRoute
  '/mascot-pick': typeof MascotPickRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/pal': typeof PalRoute
  '/parent': typeof ParentRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/profiles': typeof ProfilesRoute
  '/qa-gallery': typeof QaGalleryRoute
  '/qa-handwriting': typeof QaHandwritingRoute
  '/qa-item': typeof QaItemRoute
  '/qa-pal': typeof QaPalRoute
  '/read': typeof ReadRoute
  '/session': typeof SessionRoute
  '/settings': typeof SettingsRoute
  '/teacher': typeof TeacherRoute
  '/terms': typeof TermsRoute
  '/claim/$code': typeof ClaimCodeRoute
  '/join/$code': typeof JoinCodeRoute
  '/onboarding/diagnostic': typeof OnboardingDiagnosticRoute
  '/onboarding/parent-results': typeof OnboardingParentResultsRoute
  '/parent/analytics': typeof ParentAnalyticsRoute
  '/parent/kids': typeof ParentKidsRoute
  '/parent/portfolio': typeof ParentPortfolioRoute
  '/parent/settings': typeof ParentSettingsRouteWithChildren
  '/parent/skill': typeof ParentSkillRoute
  '/parent/tree': typeof ParentTreeRoute
  '/play/coach': typeof PlayCoachRoute
  '/play/day-complete': typeof PlayDayCompleteRoute
  '/play/foundation': typeof PlayFoundationRoute
  '/play/math-coach': typeof PlayMathCoachRoute
  '/play/mixed': typeof PlayMixedRoute
  '/play/reading': typeof PlayReadingRoute
  '/play/recap': typeof PlayRecapRoute
  '/play/session': typeof PlaySessionRoute
  '/play/story': typeof PlayStoryRoute
  '/play/who': typeof PlayWhoRoute
  '/teacher_/start': typeof TeacherStartRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/parent/': typeof ParentIndexRoute
  '/play/': typeof PlayIndexRoute
  '/onboarding/kid/abilities': typeof OnboardingKidAbilitiesRoute
  '/onboarding/kid/abilities-math': typeof OnboardingKidAbilitiesMathRoute
  '/onboarding/kid/age': typeof OnboardingKidAgeRoute
  '/onboarding/kid/handoff': typeof OnboardingKidHandoffRoute
  '/onboarding/kid/locale': typeof OnboardingKidLocaleRoute
  '/onboarding/kid/name': typeof OnboardingKidNameRoute
  '/onboarding/kid/pal': typeof OnboardingKidPalRoute
  '/parent/settings/accessibility': typeof ParentSettingsAccessibilityRoute
  '/parent/settings/difficulty': typeof ParentSettingsDifficultyRoute
  '/parent/settings/email': typeof ParentSettingsEmailRoute
  '/parent/settings/how-it-works': typeof ParentSettingsHowItWorksRoute
  '/parent/settings/kids': typeof ParentSettingsKidsRoute
  '/parent/settings/language': typeof ParentSettingsLanguageRoute
  '/parent/settings/notifications': typeof ParentSettingsNotificationsRoute
  '/parent/settings/privacy': typeof ParentSettingsPrivacyRoute
  '/parent/settings/routine': typeof ParentSettingsRoutineRoute
  '/parent/settings/support': typeof ParentSettingsSupportRoute
  '/parent/settings/': typeof ParentSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/concept'
    | '/coppa-notice'
    | '/dashboard'
    | '/done'
    | '/dpa'
    | '/journey'
    | '/library'
    | '/mascot-pick'
    | '/onboarding'
    | '/pal'
    | '/parent'
    | '/privacy'
    | '/profiles'
    | '/qa-gallery'
    | '/qa-handwriting'
    | '/qa-item'
    | '/qa-pal'
    | '/read'
    | '/session'
    | '/settings'
    | '/teacher'
    | '/terms'
    | '/claim/$code'
    | '/join/$code'
    | '/onboarding/diagnostic'
    | '/onboarding/parent-results'
    | '/parent/analytics'
    | '/parent/kids'
    | '/parent/portfolio'
    | '/parent/settings'
    | '/parent/skill'
    | '/parent/tree'
    | '/play/coach'
    | '/play/day-complete'
    | '/play/foundation'
    | '/play/math-coach'
    | '/play/mixed'
    | '/play/reading'
    | '/play/recap'
    | '/play/session'
    | '/play/story'
    | '/play/who'
    | '/teacher/start'
    | '/onboarding/'
    | '/parent/'
    | '/play/'
    | '/onboarding/kid/abilities'
    | '/onboarding/kid/abilities-math'
    | '/onboarding/kid/age'
    | '/onboarding/kid/handoff'
    | '/onboarding/kid/locale'
    | '/onboarding/kid/name'
    | '/onboarding/kid/pal'
    | '/parent/settings/accessibility'
    | '/parent/settings/difficulty'
    | '/parent/settings/email'
    | '/parent/settings/how-it-works'
    | '/parent/settings/kids'
    | '/parent/settings/language'
    | '/parent/settings/notifications'
    | '/parent/settings/privacy'
    | '/parent/settings/routine'
    | '/parent/settings/support'
    | '/parent/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/concept'
    | '/coppa-notice'
    | '/dashboard'
    | '/done'
    | '/dpa'
    | '/journey'
    | '/library'
    | '/mascot-pick'
    | '/pal'
    | '/privacy'
    | '/profiles'
    | '/qa-gallery'
    | '/qa-handwriting'
    | '/qa-item'
    | '/qa-pal'
    | '/read'
    | '/session'
    | '/settings'
    | '/teacher'
    | '/terms'
    | '/claim/$code'
    | '/join/$code'
    | '/onboarding/diagnostic'
    | '/onboarding/parent-results'
    | '/parent/analytics'
    | '/parent/kids'
    | '/parent/portfolio'
    | '/parent/skill'
    | '/parent/tree'
    | '/play/coach'
    | '/play/day-complete'
    | '/play/foundation'
    | '/play/math-coach'
    | '/play/mixed'
    | '/play/reading'
    | '/play/recap'
    | '/play/session'
    | '/play/story'
    | '/play/who'
    | '/teacher/start'
    | '/onboarding'
    | '/parent'
    | '/play'
    | '/onboarding/kid/abilities'
    | '/onboarding/kid/abilities-math'
    | '/onboarding/kid/age'
    | '/onboarding/kid/handoff'
    | '/onboarding/kid/locale'
    | '/onboarding/kid/name'
    | '/onboarding/kid/pal'
    | '/parent/settings/accessibility'
    | '/parent/settings/difficulty'
    | '/parent/settings/email'
    | '/parent/settings/how-it-works'
    | '/parent/settings/kids'
    | '/parent/settings/language'
    | '/parent/settings/notifications'
    | '/parent/settings/privacy'
    | '/parent/settings/routine'
    | '/parent/settings/support'
    | '/parent/settings'
  id:
    | '__root__'
    | '/'
    | '/concept'
    | '/coppa-notice'
    | '/dashboard'
    | '/done'
    | '/dpa'
    | '/journey'
    | '/library'
    | '/mascot-pick'
    | '/onboarding'
    | '/pal'
    | '/parent'
    | '/privacy'
    | '/profiles'
    | '/qa-gallery'
    | '/qa-handwriting'
    | '/qa-item'
    | '/qa-pal'
    | '/read'
    | '/session'
    | '/settings'
    | '/teacher'
    | '/terms'
    | '/claim/$code'
    | '/join/$code'
    | '/onboarding/diagnostic'
    | '/onboarding/parent-results'
    | '/parent/analytics'
    | '/parent/kids'
    | '/parent/portfolio'
    | '/parent/settings'
    | '/parent/skill'
    | '/parent/tree'
    | '/play/coach'
    | '/play/day-complete'
    | '/play/foundation'
    | '/play/math-coach'
    | '/play/mixed'
    | '/play/reading'
    | '/play/recap'
    | '/play/session'
    | '/play/story'
    | '/play/who'
    | '/teacher_/start'
    | '/onboarding/'
    | '/parent/'
    | '/play/'
    | '/onboarding/kid/abilities'
    | '/onboarding/kid/abilities-math'
    | '/onboarding/kid/age'
    | '/onboarding/kid/handoff'
    | '/onboarding/kid/locale'
    | '/onboarding/kid/name'
    | '/onboarding/kid/pal'
    | '/parent/settings/accessibility'
    | '/parent/settings/difficulty'
    | '/parent/settings/email'
    | '/parent/settings/how-it-works'
    | '/parent/settings/kids'
    | '/parent/settings/language'
    | '/parent/settings/notifications'
    | '/parent/settings/privacy'
    | '/parent/settings/routine'
    | '/parent/settings/support'
    | '/parent/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConceptRoute: typeof ConceptRoute
  CoppaNoticeRoute: typeof CoppaNoticeRoute
  DashboardRoute: typeof DashboardRoute
  DoneRoute: typeof DoneRoute
  DpaRoute: typeof DpaRoute
  JourneyRoute: typeof JourneyRoute
  LibraryRoute: typeof LibraryRoute
  MascotPickRoute: typeof MascotPickRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PalRoute: typeof PalRoute
  ParentRoute: typeof ParentRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  ProfilesRoute: typeof ProfilesRoute
  QaGalleryRoute: typeof QaGalleryRoute
  QaHandwritingRoute: typeof QaHandwritingRoute
  QaItemRoute: typeof QaItemRoute
  QaPalRoute: typeof QaPalRoute
  ReadRoute: typeof ReadRoute
  SessionRoute: typeof SessionRoute
  SettingsRoute: typeof SettingsRoute
  TeacherRoute: typeof TeacherRoute
  TermsRoute: typeof TermsRoute
  ClaimCodeRoute: typeof ClaimCodeRoute
  JoinCodeRoute: typeof JoinCodeRoute
  PlayCoachRoute: typeof PlayCoachRoute
  PlayDayCompleteRoute: typeof PlayDayCompleteRoute
  PlayFoundationRoute: typeof PlayFoundationRoute
  PlayMathCoachRoute: typeof PlayMathCoachRoute
  PlayMixedRoute: typeof PlayMixedRoute
  PlayReadingRoute: typeof PlayReadingRoute
  PlayRecapRoute: typeof PlayRecapRoute
  PlaySessionRoute: typeof PlaySessionRoute
  PlayStoryRoute: typeof PlayStoryRoute
  PlayWhoRoute: typeof PlayWhoRoute
  TeacherStartRoute: typeof TeacherStartRoute
  PlayIndexRoute: typeof PlayIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher': {
      id: '/teacher'
      path: '/teacher'
      fullPath: '/teacher'
      preLoaderRoute: typeof TeacherRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session': {
      id: '/session'
      path: '/session'
      fullPath: '/session'
      preLoaderRoute: typeof SessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read': {
      id: '/read'
      path: '/read'
      fullPath: '/read'
      preLoaderRoute: typeof ReadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa-pal': {
      id: '/qa-pal'
      path: '/qa-pal'
      fullPath: '/qa-pal'
      preLoaderRoute: typeof QaPalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa-item': {
      id: '/qa-item'
      path: '/qa-item'
      fullPath: '/qa-item'
      preLoaderRoute: typeof QaItemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa-handwriting': {
      id: '/qa-handwriting'
      path: '/qa-handwriting'
      fullPath: '/qa-handwriting'
      preLoaderRoute: typeof QaHandwritingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa-gallery': {
      id: '/qa-gallery'
      path: '/qa-gallery'
      fullPath: '/qa-gallery'
      preLoaderRoute: typeof QaGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles': {
      id: '/profiles'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof ProfilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent': {
      id: '/parent'
      path: '/parent'
      fullPath: '/parent'
      preLoaderRoute: typeof ParentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pal': {
      id: '/pal'
      path: '/pal'
      fullPath: '/pal'
      preLoaderRoute: typeof PalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mascot-pick': {
      id: '/mascot-pick'
      path: '/mascot-pick'
      fullPath: '/mascot-pick'
      preLoaderRoute: typeof MascotPickRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journey': {
      id: '/journey'
      path: '/journey'
      fullPath: '/journey'
      preLoaderRoute: typeof JourneyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dpa': {
      id: '/dpa'
      path: '/dpa'
      fullPath: '/dpa'
      preLoaderRoute: typeof DpaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/done': {
      id: '/done'
      path: '/done'
      fullPath: '/done'
      preLoaderRoute: typeof DoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coppa-notice': {
      id: '/coppa-notice'
      path: '/coppa-notice'
      fullPath: '/coppa-notice'
      preLoaderRoute: typeof CoppaNoticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concept': {
      id: '/concept'
      path: '/concept'
      fullPath: '/concept'
      preLoaderRoute: typeof ConceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/': {
      id: '/play/'
      path: '/play'
      fullPath: '/play/'
      preLoaderRoute: typeof PlayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/': {
      id: '/parent/'
      path: '/'
      fullPath: '/parent/'
      preLoaderRoute: typeof ParentIndexRouteImport
      parentRoute: typeof ParentRoute
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/teacher_/start': {
      id: '/teacher_/start'
      path: '/teacher/start'
      fullPath: '/teacher/start'
      preLoaderRoute: typeof TeacherStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/who': {
      id: '/play/who'
      path: '/play/who'
      fullPath: '/play/who'
      preLoaderRoute: typeof PlayWhoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/story': {
      id: '/play/story'
      path: '/play/story'
      fullPath: '/play/story'
      preLoaderRoute: typeof PlayStoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/session': {
      id: '/play/session'
      path: '/play/session'
      fullPath: '/play/session'
      preLoaderRoute: typeof PlaySessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/recap': {
      id: '/play/recap'
      path: '/play/recap'
      fullPath: '/play/recap'
      preLoaderRoute: typeof PlayRecapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/reading': {
      id: '/play/reading'
      path: '/play/reading'
      fullPath: '/play/reading'
      preLoaderRoute: typeof PlayReadingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/mixed': {
      id: '/play/mixed'
      path: '/play/mixed'
      fullPath: '/play/mixed'
      preLoaderRoute: typeof PlayMixedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/math-coach': {
      id: '/play/math-coach'
      path: '/play/math-coach'
      fullPath: '/play/math-coach'
      preLoaderRoute: typeof PlayMathCoachRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/foundation': {
      id: '/play/foundation'
      path: '/play/foundation'
      fullPath: '/play/foundation'
      preLoaderRoute: typeof PlayFoundationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/day-complete': {
      id: '/play/day-complete'
      path: '/play/day-complete'
      fullPath: '/play/day-complete'
      preLoaderRoute: typeof PlayDayCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play/coach': {
      id: '/play/coach'
      path: '/play/coach'
      fullPath: '/play/coach'
      preLoaderRoute: typeof PlayCoachRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/tree': {
      id: '/parent/tree'
      path: '/tree'
      fullPath: '/parent/tree'
      preLoaderRoute: typeof ParentTreeRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/skill': {
      id: '/parent/skill'
      path: '/skill'
      fullPath: '/parent/skill'
      preLoaderRoute: typeof ParentSkillRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/settings': {
      id: '/parent/settings'
      path: '/settings'
      fullPath: '/parent/settings'
      preLoaderRoute: typeof ParentSettingsRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/portfolio': {
      id: '/parent/portfolio'
      path: '/portfolio'
      fullPath: '/parent/portfolio'
      preLoaderRoute: typeof ParentPortfolioRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/kids': {
      id: '/parent/kids'
      path: '/kids'
      fullPath: '/parent/kids'
      preLoaderRoute: typeof ParentKidsRouteImport
      parentRoute: typeof ParentRoute
    }
    '/parent/analytics': {
      id: '/parent/analytics'
      path: '/analytics'
      fullPath: '/parent/analytics'
      preLoaderRoute: typeof ParentAnalyticsRouteImport
      parentRoute: typeof ParentRoute
    }
    '/onboarding/parent-results': {
      id: '/onboarding/parent-results'
      path: '/parent-results'
      fullPath: '/onboarding/parent-results'
      preLoaderRoute: typeof OnboardingParentResultsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/diagnostic': {
      id: '/onboarding/diagnostic'
      path: '/diagnostic'
      fullPath: '/onboarding/diagnostic'
      preLoaderRoute: typeof OnboardingDiagnosticRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/join/$code': {
      id: '/join/$code'
      path: '/join/$code'
      fullPath: '/join/$code'
      preLoaderRoute: typeof JoinCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claim/$code': {
      id: '/claim/$code'
      path: '/claim/$code'
      fullPath: '/claim/$code'
      preLoaderRoute: typeof ClaimCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent/settings/': {
      id: '/parent/settings/'
      path: '/'
      fullPath: '/parent/settings/'
      preLoaderRoute: typeof ParentSettingsIndexRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/support': {
      id: '/parent/settings/support'
      path: '/support'
      fullPath: '/parent/settings/support'
      preLoaderRoute: typeof ParentSettingsSupportRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/routine': {
      id: '/parent/settings/routine'
      path: '/routine'
      fullPath: '/parent/settings/routine'
      preLoaderRoute: typeof ParentSettingsRoutineRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/privacy': {
      id: '/parent/settings/privacy'
      path: '/privacy'
      fullPath: '/parent/settings/privacy'
      preLoaderRoute: typeof ParentSettingsPrivacyRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/notifications': {
      id: '/parent/settings/notifications'
      path: '/notifications'
      fullPath: '/parent/settings/notifications'
      preLoaderRoute: typeof ParentSettingsNotificationsRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/language': {
      id: '/parent/settings/language'
      path: '/language'
      fullPath: '/parent/settings/language'
      preLoaderRoute: typeof ParentSettingsLanguageRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/kids': {
      id: '/parent/settings/kids'
      path: '/kids'
      fullPath: '/parent/settings/kids'
      preLoaderRoute: typeof ParentSettingsKidsRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/how-it-works': {
      id: '/parent/settings/how-it-works'
      path: '/how-it-works'
      fullPath: '/parent/settings/how-it-works'
      preLoaderRoute: typeof ParentSettingsHowItWorksRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/email': {
      id: '/parent/settings/email'
      path: '/email'
      fullPath: '/parent/settings/email'
      preLoaderRoute: typeof ParentSettingsEmailRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/difficulty': {
      id: '/parent/settings/difficulty'
      path: '/difficulty'
      fullPath: '/parent/settings/difficulty'
      preLoaderRoute: typeof ParentSettingsDifficultyRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/parent/settings/accessibility': {
      id: '/parent/settings/accessibility'
      path: '/accessibility'
      fullPath: '/parent/settings/accessibility'
      preLoaderRoute: typeof ParentSettingsAccessibilityRouteImport
      parentRoute: typeof ParentSettingsRoute
    }
    '/onboarding/kid/pal': {
      id: '/onboarding/kid/pal'
      path: '/kid/pal'
      fullPath: '/onboarding/kid/pal'
      preLoaderRoute: typeof OnboardingKidPalRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/kid/name': {
      id: '/onboarding/kid/name'
      path: '/kid/name'
      fullPath: '/onboarding/kid/name'
      preLoaderRoute: typeof OnboardingKidNameRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/kid/locale': {
      id: '/onboarding/kid/locale'
      path: '/kid/locale'
      fullPath: '/onboarding/kid/locale'
      preLoaderRoute: typeof OnboardingKidLocaleRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/kid/handoff': {
      id: '/onboarding/kid/handoff'
      path: '/kid/handoff'
      fullPath: '/onboarding/kid/handoff'
      preLoaderRoute: typeof OnboardingKidHandoffRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/kid/age': {
      id: '/onboarding/kid/age'
      path: '/kid/age'
      fullPath: '/onboarding/kid/age'
      preLoaderRoute: typeof OnboardingKidAgeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/kid/abilities-math': {
      id: '/onboarding/kid/abilities-math'
      path: '/kid/abilities-math'
      fullPath: '/onboarding/kid/abilities-math'
      preLoaderRoute: typeof OnboardingKidAbilitiesMathRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/kid/abilities': {
      id: '/onboarding/kid/abilities'
      path: '/kid/abilities'
      fullPath: '/onboarding/kid/abilities'
      preLoaderRoute: typeof OnboardingKidAbilitiesRouteImport
      parentRoute: typeof OnboardingRoute
    }
  }
}

interface OnboardingRouteChildren {
  OnboardingDiagnosticRoute: typeof OnboardingDiagnosticRoute
  OnboardingParentResultsRoute: typeof OnboardingParentResultsRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  OnboardingKidAbilitiesRoute: typeof OnboardingKidAbilitiesRoute
  OnboardingKidAbilitiesMathRoute: typeof OnboardingKidAbilitiesMathRoute
  OnboardingKidAgeRoute: typeof OnboardingKidAgeRoute
  OnboardingKidHandoffRoute: typeof OnboardingKidHandoffRoute
  OnboardingKidLocaleRoute: typeof OnboardingKidLocaleRoute
  OnboardingKidNameRoute: typeof OnboardingKidNameRoute
  OnboardingKidPalRoute: typeof OnboardingKidPalRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingDiagnosticRoute: OnboardingDiagnosticRoute,
  OnboardingParentResultsRoute: OnboardingParentResultsRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  OnboardingKidAbilitiesRoute: OnboardingKidAbilitiesRoute,
  OnboardingKidAbilitiesMathRoute: OnboardingKidAbilitiesMathRoute,
  OnboardingKidAgeRoute: OnboardingKidAgeRoute,
  OnboardingKidHandoffRoute: OnboardingKidHandoffRoute,
  OnboardingKidLocaleRoute: OnboardingKidLocaleRoute,
  OnboardingKidNameRoute: OnboardingKidNameRoute,
  OnboardingKidPalRoute: OnboardingKidPalRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface ParentSettingsRouteChildren {
  ParentSettingsAccessibilityRoute: typeof ParentSettingsAccessibilityRoute
  ParentSettingsDifficultyRoute: typeof ParentSettingsDifficultyRoute
  ParentSettingsEmailRoute: typeof ParentSettingsEmailRoute
  ParentSettingsHowItWorksRoute: typeof ParentSettingsHowItWorksRoute
  ParentSettingsKidsRoute: typeof ParentSettingsKidsRoute
  ParentSettingsLanguageRoute: typeof ParentSettingsLanguageRoute
  ParentSettingsNotificationsRoute: typeof ParentSettingsNotificationsRoute
  ParentSettingsPrivacyRoute: typeof ParentSettingsPrivacyRoute
  ParentSettingsRoutineRoute: typeof ParentSettingsRoutineRoute
  ParentSettingsSupportRoute: typeof ParentSettingsSupportRoute
  ParentSettingsIndexRoute: typeof ParentSettingsIndexRoute
}

const ParentSettingsRouteChildren: ParentSettingsRouteChildren = {
  ParentSettingsAccessibilityRoute: ParentSettingsAccessibilityRoute,
  ParentSettingsDifficultyRoute: ParentSettingsDifficultyRoute,
  ParentSettingsEmailRoute: ParentSettingsEmailRoute,
  ParentSettingsHowItWorksRoute: ParentSettingsHowItWorksRoute,
  ParentSettingsKidsRoute: ParentSettingsKidsRoute,
  ParentSettingsLanguageRoute: ParentSettingsLanguageRoute,
  ParentSettingsNotificationsRoute: ParentSettingsNotificationsRoute,
  ParentSettingsPrivacyRoute: ParentSettingsPrivacyRoute,
  ParentSettingsRoutineRoute: ParentSettingsRoutineRoute,
  ParentSettingsSupportRoute: ParentSettingsSupportRoute,
  ParentSettingsIndexRoute: ParentSettingsIndexRoute,
}

const ParentSettingsRouteWithChildren = ParentSettingsRoute._addFileChildren(
  ParentSettingsRouteChildren,
)

interface ParentRouteChildren {
  ParentAnalyticsRoute: typeof ParentAnalyticsRoute
  ParentKidsRoute: typeof ParentKidsRoute
  ParentPortfolioRoute: typeof ParentPortfolioRoute
  ParentSettingsRoute: typeof ParentSettingsRouteWithChildren
  ParentSkillRoute: typeof ParentSkillRoute
  ParentTreeRoute: typeof ParentTreeRoute
  ParentIndexRoute: typeof ParentIndexRoute
}

const ParentRouteChildren: ParentRouteChildren = {
  ParentAnalyticsRoute: ParentAnalyticsRoute,
  ParentKidsRoute: ParentKidsRoute,
  ParentPortfolioRoute: ParentPortfolioRoute,
  ParentSettingsRoute: ParentSettingsRouteWithChildren,
  ParentSkillRoute: ParentSkillRoute,
  ParentTreeRoute: ParentTreeRoute,
  ParentIndexRoute: ParentIndexRoute,
}

const ParentRouteWithChildren =
  ParentRoute._addFileChildren(ParentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConceptRoute: ConceptRoute,
  CoppaNoticeRoute: CoppaNoticeRoute,
  DashboardRoute: DashboardRoute,
  DoneRoute: DoneRoute,
  DpaRoute: DpaRoute,
  JourneyRoute: JourneyRoute,
  LibraryRoute: LibraryRoute,
  MascotPickRoute: MascotPickRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  PalRoute: PalRoute,
  ParentRoute: ParentRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  ProfilesRoute: ProfilesRoute,
  QaGalleryRoute: QaGalleryRoute,
  QaHandwritingRoute: QaHandwritingRoute,
  QaItemRoute: QaItemRoute,
  QaPalRoute: QaPalRoute,
  ReadRoute: ReadRoute,
  SessionRoute: SessionRoute,
  SettingsRoute: SettingsRoute,
  TeacherRoute: TeacherRoute,
  TermsRoute: TermsRoute,
  ClaimCodeRoute: ClaimCodeRoute,
  JoinCodeRoute: JoinCodeRoute,
  PlayCoachRoute: PlayCoachRoute,
  PlayDayCompleteRoute: PlayDayCompleteRoute,
  PlayFoundationRoute: PlayFoundationRoute,
  PlayMathCoachRoute: PlayMathCoachRoute,
  PlayMixedRoute: PlayMixedRoute,
  PlayReadingRoute: PlayReadingRoute,
  PlayRecapRoute: PlayRecapRoute,
  PlaySessionRoute: PlaySessionRoute,
  PlayStoryRoute: PlayStoryRoute,
  PlayWhoRoute: PlayWhoRoute,
  TeacherStartRoute: TeacherStartRoute,
  PlayIndexRoute: PlayIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
